import { Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { ApiService } from '../api-service.service';

@Injectable({
  providedIn: 'root'
})

export class AuthService {

  constructor(private api: ApiService, private router: Router) { }


  // Register an user

  registerUser(params) {

    return this.api.post('/api/user/register', params)

  }

  // Get User by ID

  getUserbyID() {

    let headers:any = {Authorization: 'Bearer '+ this.getUser().token}

    return this.api.get('/api/user/'+this.getUser().user_id,null,headers);
  }

  // Storaging on local storage the user info

  setUser(user){

    localStorage.setItem('user', JSON.stringify(user))

  }

  // Updatinga n user

  updateUser(params){

    let headers:any = {Authorization: 'Bearer '+ this.getUser().token}

    return this.api.put('/api/user/'+this.getUser().user_id,null,params,headers);

  }

  // Returning user information

  getUser(){

    return JSON.parse(localStorage.getItem('user'))
  
  }

  // Verifying if there is a logged user

  isAuthenticated() {

    return localStorage.getItem('user')

  }

  // Verify if the user exist we introduce only the email and the system will reshape it for request

  isUser(params) {

    let requestParams = {

      email: params

    }

    return this.api.post('/api/user/exist', requestParams)

  }

  // login the user

  loginUser(params) {

    return this.api.post('/api/user/login', params)

  }

  // Resends an email with a new password

  forgotPassword(params) {

    return this.api.post('/api/user/password/forgot', params)

  }

  // Logout 



}
